export const MS_PER_MINUTE = 60000;
export const MIN_PER_HOURS = 60;
export const HOURS_PER_DAY = 24;
export const DISPLAY_DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DISPLAY_DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm';
